import EditBasicInfoModalContainer from "./EditBasicInfoModalContainer";

export default EditBasicInfoModalContainer;
